<template>
  <el-dialog title="增加客户" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="门店名称" :label-width="formLabelWidth" prop="deptname">
                  <el-input v-model="form.deptname" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item label="所属区域" :label-width="formLabelWidth" prop="city">
                <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city"
                              @city="onChangeCity" :area="form.county" @area="onChangeArea"></v-distpicker>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="地址" :label-width="formLabelWidth" prop="deliveryaddress">
            <el-input v-model="form.deliveryaddress" auto-complete="off"  :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="联系人" :label-width="formLabelWidth" prop="linkman">
            <el-input v-model="form.linkman" auto-complete="off"  :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="手机号" :label-width="formLabelWidth" prop="linkmantel">
            <el-input v-model="form.linkmantel" auto-complete="off"  :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item label="附件" :label-width="formLabelWidth" prop="attguid">
                <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="!CanEdit"
                              groupType="externaldept" :limit="10"></CommonUpload>
              </el-form-item>
            </el-col>
          </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" v-if="CanEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {registerCompany} from '@/api/set/externaldept';
  import {attUUID} from '@/api/attachment';

  export default {
    name: "ExternaldeptAdd",
    data() {
      return {
        CanEdit: true,
        dialogFormVisible: false,
        form: {  //表单数据
          tenantid: '',
          deptname: '',
          province: '',
          city: '',
          county: '',
          deliveryaddress: '',
          linkmantel: '',
          linkman: '',
          password: '',
          attguid: ''
        },
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。
          isperson: [],
          settingmenthod: [],
          unitgroup: []
        },
        parameterData: [],
        formLabelWidth: '120px',
        formLabelWidth2: '70px',
        rules: {////////定义正则验证字段。
          deptname: [
            {required: true, message: '请输入门店名称', trigger: 'blur'},
          ],
          deliveryaddress: [
            {required: true, message: '请输入门店地址', trigger: 'blur'},
          ],
          city: [
            {required: true, message: '请选择所属区域', trigger: 'blur'},
          ],
          linkman: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
          ],
          linkmantel: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      }, onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      }, onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      show() {
        this.form.deptname = ''
        this.form.province = ''
        this.form.city = ''
        this.form.county = ''
        this.form.deliveryaddress = ''
        this.form.linkmantel = ''
        this.form.linkman = ''
        this.form.attguid = attUUID();
        if (this.$refs.refattguid) {
          this.$refs.refattguid.reset();
        }
        this.dialogFormVisible = true
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            registerCompany(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '录入成功，等待审核！',
                  type: 'success'
                })
                this.dialogFormVisible = false;
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        })
      },
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/ExternaldeptAdd.vue